exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_cn0kuz8j{width:100%;box-sizing:border-box;height:64px;position:relative}.container_cn0kuz8j[centered=true]{margin:auto}.container_cn0kuz8j:after{content:\"\";display:block;position:absolute;left:0;top:0;right:0;bottom:0;box-sizing:border-box;border:1px solid hsla(0,0%,100%,.6)}", ""]);

// exports
exports.locals = {
	"container": "container_cn0kuz8j"
};